module.exports = __webpack_public_path__ + "static/assets/ced570627c7619744984d09d33b81676.png";